import React from "react";
import translations from "./data/translations";

const LocaleContext = React.createContext();

// La langue est portée par l'URL : "/" = français, "/en" = anglais.
// C'est volontaire — chaque langue a sa propre URL indexable, ce qui est
// la seule structure que Google sait interpréter avec les balises hreflang.
const LocaleProvider = ({ locale, children }) => {
  const t = translations[locale] || translations.fr;
  const otherLocale = locale === "en" ? "fr" : "en";
  // Préfixe à ajouter aux liens internes pour rester dans la même langue
  const prefix = locale === "en" ? "/en" : "";

  return (
    <LocaleContext.Provider
      value={{
        locale,
        t,
        prefix,
        otherLocale,
        otherPath: otherLocale === "en" ? "/en" : "/",
      }}
    >
      {children}
    </LocaleContext.Provider>
  );
};

const useI18n = () => React.useContext(LocaleContext);

export { LocaleContext, LocaleProvider, useI18n };
